import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import moment from 'moment';
import { extendRealEstateEvent } from '../api';

function useExtendRealEstateEvent(realEstateEventId: number, eventEndTime: string, onExtend?: () => void) {
  const { enqueueSnackbar } = useSnackbar();

  const [state, setState] = useState<{ loading: boolean; error: string | null }>({ loading: false, error: null });

  async function handleExtendEvent() {
    try {
      setState({ loading: true, error: null });

      await extendRealEstateEvent({ realEstateEventId, eventEndTime: moment(eventEndTime).toDate().toISOString() });

      if (onExtend) onExtend();
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { handleExtendEvent, extendEventState: state };
}

export default useExtendRealEstateEvent;
